import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import axios from "axios";
import jsPDF from "jspdf";
import html2pdf from 'html2pdf.js';
import html2canvas from "html2canvas";
import ConfirmDialog from "./ConfirmDialog"; 
import webform from "../styles/webform.css";

import {
  Button,
  Box,
  Typography,
  Divider,
  Paper,
  Grid2
} from "@mui/material";

const ReviewForm = ({ onPrevious, onSubmit }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [appId, setAppId] = useState(null);
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState(false);
const [error, setError] = useState(false);
const [message, setMessage] = useState("");
const [createdAt, setCreatedAt] = useState("");

  const { watch, getValues } = useFormContext();
  const formData = watch();

  console.log( "land" , watch.isLand);

  // const prevoiusCheck = watch("isPreviousAddressSame");

  const handleSubmitConfirmed = async () => {
    setLoading(true);
    setError(false);
    setSuccess(false);
    setMessage("");
  
    const data = getValues();
  
    try {
      const formDataToSend = new FormData();
  
      // Append all non-file fields
      for (const key in data) {
        if (!["familyMembers", "front_id", "back_id", "residence_card"].includes(key)) {
          formDataToSend.append(key, data[key]);
        }
      }
  
      // Validate and append files
      if (data.front_id instanceof Blob) {
        formDataToSend.append("front_id", data.front_id);
      } else {
        throw new Error("❌ لم يتم تحميل وجه البطاقة");
      }
  
      if (data.back_id instanceof Blob) {
        formDataToSend.append("back_id", data.back_id);
      } else {
        throw new Error("❌ لم يتم تحميل ظهر البطاقة");
      }
  
      if (data.residence_card instanceof Blob) {
        formDataToSend.append("residence_card", data.residence_card);
      } else {
        throw new Error("❌ لم يتم تحميل بطاقة السكن");
      }
  
      // Append family members
      formDataToSend.append("familyMembers", JSON.stringify(data.familyMembers || []));
  
      // Send form data to backend
      const res = await axios.post("https://test2.alshuhadaa.gov.iq/api/form", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
  
      const { applicationId, createdAt } = res.data;
      const formattedDate = new Date(createdAt).toISOString().split("T")[0];
      
      setAppId(applicationId);
      setCreatedAt(formattedDate);
      setSuccess(true);
      await exportToPdf(applicationId, createdAt);
    } catch (err) {
      let msg = "حدث خطأ أثناء الإرسال، حاول مرة أخرى.";
      if (err?.response?.data?.type === "duplicate") {
        msg = "⚠️ يوجد تقديم سابق بنفس الاسم الرباعي واسم الأم الثلاثي.";
      } else if (err?.response?.data?.message) {
        msg = err.response.data.message;
      }
      setMessage(msg);
      setError(true);
      console.error("❌ Error submitting form:", err);
    } finally {
      setLoading(false);
    }
  };
  
  // Clean up object URLs
  useEffect(() => {
    const urls = ['front_id', 'back_id', 'residence_card']
      .map(key => formData[key])
      .filter(Boolean)
      .map(file => URL.createObjectURL(file));

    return () => {
      urls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [formData]);

  const exportToPdf = async (applicationId, createdAt) => {
    const element = document.getElementById("review-section");
    if (!element) return;
  
    const clone = element.cloneNode(true);
    clone.style.fontFamily = "Tajawal, Arial, sans-serif";
    clone.style.direction = "rtl";
    clone.style.width = "210mm";
    clone.style.padding = "20px";
    clone.style.fontSize = "18px";
  
    const header = document.createElement("div");
    header.innerHTML = `
          <div style="text-align: center; margin-bottom: 16px;">
      <img src="/logo.png" alt="Logo" style="width: 60px; margin: 0 auto 10px;" />
      <div style="font-weight: bold; font-size: 18px;">مؤسسة الشهداء</div>
      <div style="font-size: 22px;">استمارة جمع بيانات من ضحايا العمليات الحربية والأخطاء العسكرية والعمليات الإرهابية</div>
      <div style="font-size: 18px; font-weight: bold;">رقم المعاملة: ${applicationId}</div>
    </div>
    `;
    clone.prepend(header);
  
    const footer = document.createElement("div");
    footer.innerHTML = `
     <div style="margin-top: 40px; font-size: 18px;">
      <p><strong>يرفق مع الاستمارة:</strong> البطاقة الوطنية وجهين + بطاقة السكن (نسخ مصورة)</p>
      <p>يتحمل مقدم الاستمارة المسؤولية القانونية كاملة عند تقديم أي بيانات غير صحيحة.</p>
      <p>على ذوي الشهيد/الجريح تقديم استمارة واحدة فقط.</p>
      <br/>
      <div style="display: flex; justify-content: space-between;">
        <div>
          <p>اسم مقدم الاستمارة: ____________________</p>
          <p>صلته بالشهيد/الجريح: ____________________</p>
        </div>
        <div style="text-align: left;">
          <p>التوقيع: _______________</p>
        </div>
      </div>
    </div>
    `;
    clone.appendChild(footer);
  
    document.body.appendChild(clone);
  
    const opt = {
      margin: [10, 10, 10, 10],
      filename: `استمارة_المتقدم_${applicationId}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'] }
    };
  
    await html2pdf().set(opt).from(clone).save();
  
    document.body.removeChild(clone);
  };
  
  

  const renderAttachment = (label, file) => {
    if (!file) return <Typography color="error">لم يتم الإرفاق</Typography>;

    const fileURL = URL.createObjectURL(file);
    const isImage = file.type.startsWith("image/");
    const isPDF = file.type === "application/pdf";

    return (
      <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>{label}</Typography>
        {isImage ? (
          <img
            src={fileURL}
            alt={label}
            style={{ maxWidth: "100%", height: 200, objectFit: "cover" }}
          />
        ) : isPDF ? (
          <object
            data={fileURL}
            type="application/pdf"
            width="100%"
            height="300"
          >
            <p>
              لا يمكن عرض الملف،{" "}
              <a href={fileURL} target="_blank" rel="noreferrer">اضغط هنا لتحميله</a>
            </p>
          </object>
        ) : (
          <Typography>{file.name}</Typography>
        )}
      </Paper>
    );
  };
  const districtOptions = {
    1: "مديرية شهداء الكرخ",
    2: "مديرية شهداء الصدر",
    3: "مديرية شهداء الرصافة",
    4: "مديرية شهداء كربلاء المقدسة",
    5: "مديرية شهداء النجف الاشرف",
    6: "مديرية شهداء بابل",
    7: "مديرية شهداء واسط",
    8: "مديرية شهداء الديوانية",
    9: "مديرية شهداء المثنى",
    10: "مديرية شهداء البصرة",
    11: "مديرية شهداء ذي قار",
    12: "مديرية شهداء ميسان",
    13: "مديرية شهداء ديالى",
    14: "مديرية شهداء نينوى",
    15: "مديرية شهداء الانبار",
    16: "مديرية شهداء صلاح الدين",
    17: "مديرية شهداء كركوك",
    18: "مديرية شهداء شمال البصرة"
  };

  const personalFields = [
    { label: "نوع الضرر", value: watch("damage") === 1 ? "شهيد" : "مصاب" },
    { label: "المديرية", value: districtOptions[watch("district")] || "غير متوفر" },
    { label: "الاسم الاول", value: watch("firstName") },
    { label: "اسم الاب", value: watch("secondName") },
    { label: "اسم الجد", value: watch("thirdName") },
    { label: "اسم اب الجد", value: watch("fourthName") },
    { label: "اللقب", value: watch("surname") },
    { label: "اسم الام", value: watch("motherName") },
    { label: "اسم اب الام", value: watch("MotherName2") },
    { label: "اسم جد الام", value: watch("MotherName3") },
    { label: "تاريخ الميلاد", value: watch("birthdate") },
    { label: "الجنس", value: watch("sex") },
    { label: "الحالة الاجتماعية", value: watch("socialStatus") },
    { label: "عدد الزوجات", value: watch("numberOfWives") },
    { label: "المهنة", value: watch("profession") },
    { label: "الوزارة", value: watch("ministry") },
    { label: "الهاتف 1", value: watch("phone1") },
    { label: "الهاتف 2", value: watch("phone2") },
    { label: "الهاتف 3", value: watch("phone3") },
    { label: "الملاحظات", value: watch("notes") || "لا توجد" },
    // { label: "هل يوجد مستفيدين من العائلة؟", value: watch("familyMembers")?.length > 0 ? "نعم" : "لا" },
    { label: "المحافظة (السكن الحالي)", value: watch("province") },
    { label: "القضاء (السكن الحالي)", value: watch("court") },
    { label: "محلة (السكن الحالي)", value: watch("muhalla") },
    { label: "زقاق (السكن الحالي)", value: watch("street") },
    { label: "دار (السكن الحالي)", value: watch("dar") },
    // { label: "هل يوجد محل سكن سابق؟", value: watch("isPreviousAddressSame") ? "نعم" : "لا" },
    
      { label: "المحافظة (السكن السابق)", value: watch("previousProvince") },
      { label: "القضاء (السكن السابق)", value: watch("previousCourt") },
      { label: "محلة (السكن السابق)", value: watch("previousMuhalla") },
      { label: "زقاق (السكن السابق)", value: watch("previousStreet") },
      { label: "دار (السكن السابق)", value: watch("previousHouseNumber") },
      { label: "مكان الحادث", value: watch("placeOfIncident") },
      { label: "تاريخ الحادث", value: watch("incidentDate") },
      {label:"هل القرار متوقف حاليا؟", value: watch("isMartyerStopped") ? "نعم" : "لا"},
      {label:"هل الوالدين او احدهما على قيد الحياة؟", value: watch("isParentAlive") ? "نعم" : "لا"},
      {label:"هل ذوي الشهيد مستلمين لقطعة ارض؟", value: watch("isLand") ? "نعم" : "لا"},
      {label:"هل ذوي الشهيد مستلمين عقاراً؟", value: watch("isApartment") ? "نعم" : "لا"},
      {label:"هل ذوي الشهيد مستلمين للبدل النقدي ؟", value: watch("isCash") ? "نعم" : "لا"},
      {label:"هل ذوي الشهيد مستلمين للراتب التقاعدي ؟", value: watch("isSalary") ? "نعم" : "لا"},
  ];

  return (
   
      <Box   sx={{
    padding: 4,
    backgroundColor: "#fff",
    border: "2px solid #000",
    borderRadius: 2,
    fontFamily: 'Arial, "Segoe UI", Tahoma, sans-serif',
    pagebreak: { mode: ['css', 'legacy'] },
    color: "#000"
  }} >
    <Box  sx={{ padding: 4, backgroundColor: "#fafafa", borderRadius: 2, boxShadow: 2, fontSize: "12px" }}>
      <Typography variant="h6" sx={{ textAlign: "center", marginBottom: 3, color: "#3f51b5" }}>
       مراجعة المعلومات قبل الارسال
      </Typography>

      {/* Personal Information */}
      <Box id="review-section" sx={{ mb: 4 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
  معلومات الشهيد / الجريح
</Typography>
<Divider sx={{ my: 1 }} />
<Box component="table" sx={{ width: "100%", borderCollapse: "collapse", mb: 3, fontSize: "16px" }}>
  <tbody>
    {[
      { label: "نوع الضرر", value: watch("damage") === 1 ? "شهيد" : "مصاب" },
      { label: "المديرية", value: districtOptions[watch("district")] || "غير متوفر" },
      { label: "الاسم الاول", value: watch("firstName") },
      { label: "اسم الاب", value: watch("secondName") },
      { label: "اسم الجد", value: watch("thirdName") },
      { label: "اسم اب الجد", value: watch("fourthName") },
      { label: "اللقب", value: watch("surname") },
      { label: "اسم الام", value: watch("motherName") },
      { label: "اسم اب الام", value: watch("MotherName2") },
      { label: "اسم جد الام", value: watch("MotherName3") },
      { label: "تاريخ الميلاد", value: watch("birthdate") },
      { label: "الجنس", value: watch("sex") },
      { label: "الحالة الاجتماعية", value: watch("socialStatus") },
      { label: "عدد الزوجات", value: watch("numberOfWives") },
    ].map((item, i) => (
      <tr key={i}>
        <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold", backgroundColor: "#f0f0f0", width: "35%", fontSize: "16px" }}>{item.label}</td>
        <td style={{ border: "1px solid #ccc", padding: "8px",fontWeight: "bold", fontSize: "16px", direction: "rtl" }}>{item.value || "غير متوفر"}</td>
      </tr>
    ))}
  </tbody>
</Box>

{/* SECTION 2: معلومات السكن الحالي */}
<Typography variant="subtitle1" className="page-break" sx={{ fontWeight: 'bold', mt: 2 }}>
  معلومات السكن الحالي
</Typography>
<Divider sx={{ my: 1 }} />
<Box component="table" sx={{ width: "100%", borderCollapse: "collapse", mb: 3 }}>
  <tbody>
    {[
      { label: "المحافظة", value: watch("province") },
      { label: "القضاء", value: watch("court") },
      { label: "المحلة", value: watch("muhalla") },
      { label: "الزقاق", value: watch("street") },
      { label: "الدار", value: watch("dar") },
    ].map((item, i) => (
      <tr key={i}>
        <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold", backgroundColor: "#f0f0f0", width: "35%", fontSize: "16px" }}>{item.label}</td>
        <td style={{ border: "1px solid #ccc", padding: "8px",fontWeight: "bold", fontSize: "16px", direction: "rtl" }}>{item.value || "غير متوفر"}</td>
      </tr>
    ))}
  </tbody>
</Box>

{/* SECTION 3: معلومات السكن السابق */}
<Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
  معلومات السكن السابق
</Typography>
<Divider sx={{ my: 1 }} />
<Box component="table" sx={{ width: "100%", borderCollapse: "collapse", mb: 3 }}>
  <tbody>
    {[
      { label: "المحافظة", value: watch("previousProvince") },
      { label: "القضاء", value: watch("previousCourt") },
      { label: "المحلة", value: watch("previousMuhalla") },
      { label: "الزقاق", value: watch("previousStreet") },
      { label: "الدار", value: watch("previousDar") },
    ].map((item, i) => (
      <tr key={i}>
        <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold", backgroundColor: "#f0f0f0", width: "35%", fontSize: "16px" }}>{item.label}</td>
        <td style={{ border: "1px solid #ccc", padding: "8px",fontWeight: "bold", fontSize: "16px", direction: "rtl" }}>{item.value || "غير متوفر"}</td>
      </tr>
    ))}
  </tbody>
</Box>

{/* SECTION 4: معلومات إضافية */}
<Typography variant="subtitle1"  sx={{ fontWeight: 'bold', mt: 2 }}>
  معلومات إضافية
</Typography>
<Divider sx={{ my: 1 }} />
<Box component="table"  sx={{ width: "100%", borderCollapse: "collapse", mb: 3 }}>
  <tbody>
    {[
      { label: "المهنة", value: watch("profession") },
      { label: "الوزارة", value: watch("ministry") },
      { label: "مكان الحادث", value: watch("placeOfIncident") },
      { label: "تاريخ الحادث", value: watch("incidentDate") },
    ].map((item, i) => (
      <tr key={i}>
        <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold", backgroundColor: "#f0f0f0", width: "35%", fontSize: "16px" }}>{item.label}</td>
        <td style={{ border: "1px solid #ccc", padding: "8px",fontWeight: "bold", fontSize: "16px", direction: "rtl" }}>{item.value || "غير متوفر"}</td>
      </tr>
    ))}
  </tbody>
</Box>

{/* SECTION 5: الحقوق المستلمة */}
<Typography variant="subtitle1" className="page-break" sx={{ fontWeight: 'bold', mt: 2 }}>
  الحقوق المستلمة
</Typography>
<Divider sx={{ my: 1 }} />
<Box component="table" sx={{ width: "100%", borderCollapse: "collapse", mb: 3 }}>
  <tbody>
    {[
      { label: "هل القرار متوقف حاليا؟", value: watch("isMartyerStopped") === "1" || watch("isMartyerStopped") === true ? "نعم" : "لا" },
      { label: "هل الوالدين او احدهما على قيد الحياة؟", value: watch("isParentAlive") === "1" || watch("isParentAlive") === true ? "نعم" : "لا" },
      { label: "هل ذوي الشهيد مستلمين لقطعة ارض؟", value: watch("isLand") === "1" || watch("isLand") === true ? "نعم" : "لا" },
      { label: "هل ذوي الشهيد مستلمين عقاراً؟", value: watch("isAppartment") === "1" || watch("isAppartment") === true ? "نعم" : "لا" },
      { label: "هل ذوي الشهيد مستلمين للبدل النقدي ؟", value: watch("isCash1") === "1" || watch("isCash1") === true ? "نعم" : "لا" },
      { label: "هل ذوي الشهيد مستلمين للراتب التقاعدي ؟", value: watch("isSalary") === "1" || watch("isSalary") === true ? "نعم" : "لا" },
    ].map((item, i) => (
      <tr key={i}>
        <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold", backgroundColor: "#f0f0f0", width: "35%", fontSize: "16px" }}>{item.label}</td>
        <td style={{ border: "1px solid #ccc", padding: "8px",fontWeight: "bold", fontSize: "16px", direction: "rtl" }}>{item.value || "غير متوفر"}</td>
      </tr>
    ))}
  </tbody>
</Box>

{/* SECTION 6: أرقام الهواتف */}
<Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
  أرقام الهواتف
</Typography>
<Divider sx={{ my: 1 }} />
<Box component="table" sx={{ width: "100%", borderCollapse: "collapse", mb: 3 }}>
  <tbody>
    {[
      { label: "الهاتف 1", value: watch("phone1") },
      { label: "الهاتف 2", value: watch("phone2") },
      { label: "الهاتف 3", value: watch("phone3") },
      { label: "الملاحظات", value: watch("notes") || "لا توجد" },
    ].map((item, i) => (
      <tr key={i}>
        <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold", backgroundColor: "#f0f0f0", width: "35%", fontSize: "16px" }}>{item.label}</td>
        <td style={{ border: "1px solid #ccc", padding: "8px",fontWeight: "bold", fontSize: "16px", direction: "rtl" }}>{item.value || "غير متوفر"}</td>
      </tr>
    ))}
  </tbody>
</Box>
      </Box>
    

      {/* Family Members */}
      {formData.familyMembers?.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#3f51b5' }}>
            أفراد العائلة
          </Typography>
          <Divider sx={{ my: 2 }} />
          {formData.familyMembers.map((member, index) => (
            <Box key={index} sx={{ mb: 2, p: 2, backgroundColor: '#ffffff', borderRadius: 2, boxShadow: 1 }}>
              <Typography><strong>الاسم:</strong> {member.benifFirstName} {member.benifSecondName} {member.benifThirdName} {member.benifFourthName}</Typography>
              <Typography><strong>اسم الام:</strong> {member.benifMotherName}</Typography>
              <Typography><strong>الصلة:</strong> {member.relation}</Typography>
              <Typography><strong>هل مستفيد من قطعة ارض:</strong> {member.land}</Typography>
              <Typography><strong>هل مستفيد من وحدة سكنية:</strong> {member.house}</Typography>
              <Typography><strong>هل مستفيد من منحة عقارية:</strong> {member.housing}</Typography>
              <Typography><strong>هل مستفيد من بدل نقدي:</strong> {member.cash}</Typography>
            </Box>
          ))}
        </Box>
      )}
      </Box>
    

      {/* Attachments */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#3f51b5' }}>
          المرفقات
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Grid2 container spacing={2}>
          <Grid2 item xs={12} md={4}>
            {renderAttachment("وجه البطاقة الموحدة", formData.front_id)}
          </Grid2>
          <Grid2 item xs={12} md={4}>
            {renderAttachment("ضهر البطاقة الموحدة", formData.back_id)}
          </Grid2>
          <Grid2 item xs={12} md={4}>
            {renderAttachment("بطاقة السكن", formData.residence_card)}
          </Grid2>
        </Grid2>
      </Box>

      {/* Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={onPrevious}
          variant="outlined"
          color="secondary"
          sx={{ padding: "10px 20px", fontSize: '16px' }}
        >
          رجوع
        </Button>
        <Button onClick={() => setDialogOpen(true)} variant="contained" color="primary">إرسال</Button>
<ConfirmDialog
        open={dialogOpen}
        loading={loading}
        success={success}
        error={error}
        message={message}
        appId={appId}
        onCancel={() => {
          setDialogOpen(false);
          setError(false);
          setSuccess(false);
        }}
        onConfirm={handleSubmitConfirmed}
        onDownload={() => exportToPdf(appId, createdAt)} // ✅ Add this line
      />
      </Box>
    </Box>
  );
};

export default ReviewForm;
